import React, { useEffect, useRef, useState } from "react";
import styles from "./BasicCleanupsFilter.module.scss";
import switchStyles from "../CleanupsFilter.module.scss";
import BasicBrownfieldFilter from "./BasicBrownfieldFilter/BasicBrownfieldFilter";
import BasicFederalFacilitiesFilter from "./BasicFederalFacilitiesFilter/BasicFederalFacilitiesFilter";
import BasicHazardWasteFilter from "./BasicHazardWasteFilter/BasicHazardWasteFilter";
import BasicIncidentCategoryFilter from "./BasicIncidentCategoryFilter/BasicIncidentCategoryFilter";
import BasicNationalSignificanceFilter from "./BasicNationalSignificanceFilter/BasicNationalSignificanceFilter";
import BasicRCRAFilter from "./BasicRCRAFilter/BasicRCRAFilter";
import BasicRecoveryActFilter from "./BasicRecoveryActFilter/BasicRecoveryActFilter";
import BasicResponseAuthorityFilter from "./BasicResponseAuthorityFilter/BasicResponseAuthorityFilter";
import BasicResponseStatusFilter from "./BasicResponseStatusFilter/BasicResponseStatusFilter";
import BasicResponseTypeFilter from "./BasicResponseTypeFilter/BasicResponseTypeFilter";
import BasicSuperfundNPLFilter from "./BasicSuperfundNPLFilter/BasicSuperfundNPLFilter";
import BasicSuperfundNonNPLFilter from "./BasicSuperfundNonNPLFilter/BasicSuperfundNonNPLFilter";
import {
  CalciteButton,
  CalcitePanel,
  CalciteSwitch,
} from "@esri/calcite-components-react";
import { formatBasicCleanupFilters } from "../cleanupQuerySpecifications";
// import config from "../../../assets/config.json";

const basicCleanupLabelToParam: Record<string, string> = {
  "Assessment Grants": "BF_ASSESS_IND = 'Y'",
  "Assessment Pilots": "BF_ASSESS_PILOT_IND = 'Y'",
  "Cleanup Grants": "BF_CLEANUP_IND = 'Y'",
  "RLF Grants": "BF_RLF_GRANT_IND = 'Y'",
  "RLF Pilots": "BF_RLF_PILOT_IND = 'Y'",
  "Multi Purpose Grants": "BF_MULTIPURPOSE_IND = 'Y'",
  "Area-Wide Planning Grants": "BF_AWP_IND = 'Y'",
  "State and Tribal 128(a) Grants": "BF_128A_IND = 'Y'",
  "State and Tribal 128(a) Pilots": "BF_128A_P_IND = 'Y'",
  "Showcase Community": "BF_SHOWCASE_IND = 'Y'",
  "Ready for Anticipated Use (Brownfield)": "BF_READY_FOR_REUSE_IND = 'Y'",
  "Current Corrective Action": "RCRA_CURRENT_IND = 'Y'",
  "Remedy Selected": "RCRA_REMEDY_SEL_IND = 'Y'",
  "Construction Complete": "RCRA_CONSTR_COMPLT_IND = 'Y'",
  "Remedy Action Complete": "RCRA_REMEDY_COMPLT_IND = 'Y'",
  "Remedy Not Yet Selected": "RCRA_REMEDY_NOT_SEL_IND = 'Y'",
  "Ready for Anticipated Use (RCRA)": "RCRA_RAU_IND = 'Y'",
  "Proposed": "SF_NPL_CODE_ALL = 'P' AND SF_NON_NPL_CODE = ''",
  "Final": "SF_NPL_CODE_ALL = 'F' AND SF_NON_NPL_CODE = ''",
  "Deleted": "SF_NPL_CODE_ALL = 'D' AND SF_NON_NPL_CODE = ''",
  "Superfund Sites Targeted for Immediate Intense Action": "SF_ADMIN_FLAG = 'Y' AND SF_NON_NPL_CODE = ''",
  "Superfund Alternative Approach (SAA) Agreement Sites": "SAA_SITE = 'Y' AND SF_NON_NPL_CODE = ''",
  "Ready for Anticipated Use (Superfund NPL)": "SF_READY_FOR_REUSE_IND = 'Y' AND SF_NPL_CODE_ALL in ('P','A','F','D') AND SF_NON_NPL_CODE = ''",
  "Assessment Needed or Ongoing": "SF_NON_NPL_STATUS_SUBCATEG ='Additional Assessment Needed/Ongoing'",
  "Not Eligible for the NPL/No Further Remedial Action Planned": "SF_NON_NPL_STATUS_CATEGORY = 'Not Eligible for the NPL/No Further Remedial Action Planned'",
  "Referred to Cleanup Program": "SF_NON_NPL_STATUS_CATEGORY = 'Referred to Cleanup Program' AND SF_NON_NPL_CODE <> ''",
  "Ready for Anticipated Use (Superfund Non-NPL)": "SF_READY_FOR_REUSE_IND = 'Y' AND SF_NON_NPL_CODE <> ''",
  "Emergency": "EPAOSC_RESP_TYPE = 'Emergency'",
  "Non-Time-Critical": "EPAOSC_RESP_TYPE = 'Non-Time-Critical'",
  "Pre-Deployment": "EPAOSC_RESP_TYPE = 'Pre-Deployment'",
  "PRP Overnight": "EPAOSC_RESP_TYPE = 'PRP Overnight'",
  "Time-Critical": "EPAOSC_RESP_TYPE = 'Time-Critical'",
  "No Category (Response Type)": "EPAOSC_RESP_TYPE = 'No Category'",
  Active: "EPAOSC_STATUS = 'ACTIVE'",
  Complete: "EPAOSC_STATUS = 'Complete'",
  "Removal Action": "EPAOSC_INCI_CATEG='REMOVAL ACTION'",
  "Removal Assessment": "EPAOSC_INCI_CATEG='REMOVAL ASSESSMENT'",
  "No Category (Incident Category)": "EPAOSC_INCI_CATEG = 'No Category'",
  "*CERCLA": "EPAOSC_RESP_AUTH='CERCLA'",
  "*CERCLA/*OPA": "EPAOSC_RESP_AUTH='CERCLA/OPA'",
  "*CWA": "EPAOSC_RESP_AUTH='CWA'",
  "*OPA": "EPAOSC_RESP_AUTH='OPA'",
  "Stafford Act": "EPAOSC_RESP_AUTH='STAFFORD ACT'",
  "No Category (Response Authority)": "(EPAOSC_RESP_AUTH = 'No Category')",
  "*BRAC (Federal Facilities)": "FD_BRAC_IND = 'Y' AND FD_SF_NPL_IND IN ('D','F','P')",
  "Superfund NPL": "FF_SF_IND = 'Y' AND (SF_NPL_CODE = 'P' OR SF_NPL_CODE_D = 'D' OR SF_NPL_CODE_F = 'F')",
  "Superfund Non-NPL": "SF_FFDOCKET_IND = 'Y' AND SF_NON_NPL_CODE IS NOT NULL",
  "*RCRA (Federal Facilities)": "FF_RCRA_IND='Y'",
  "Brownfields Properties": "STIMULUS_BF_IND='Y'",
  "Superfund (Recovery Act)": "STIMULUS_SF_IND='Y'",
  "*NPL Superfund": "FD_SF_NPL_IND <> 'N' And FD_SF_SITE_ID IS NOT NULL",
  "*Non-NPL Superfund": "FD_NON_NPL_STATUS IS NOT NULL And FD_SF_SITE_ID IS NOT NULL",
  "*BRAC (Hazardous Waste Docket)": "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_BRAC_IND = 'Y')",
  "*RCRA (Hazardous Waste Docket)": "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_RCRA_CA_IND = 'Y' AND FD_RCRA_HANDLER_ID IS NOT NULL)",
  "Other Docket Facilities": "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_FF_IND IN ('Y','N') OR FD_FF_IND IS NULL) AND (FD_SF_NPL_IND ='N' OR FD_SF_NPL_IND IS NULL) AND FD_RCRA_HANDLER_ID IS NULL AND FD_BRAC_ROUND IS NULL",
  "Incidents of National Significance": "MAP_SYMBOL_CODE='INS'",
};

const BasicCleanupsFilter = (props) => {
  const brownfieldParams = useRef<Array<any>>([]);
  const facilitiesParams = useRef<Array<any>>([]);
  const federalHazardWasteParams = useRef<Array<any>>([]);
  const incidentCategoryParams = useRef<Array<any>>([]);
  const natlSignificanceParams = useRef<Array<any>>([]);
  const rcraParams = useRef<Array<any>>([]);
  const recoveryActParams = useRef<Array<any>>([]);
  const responseAuthorityParams = useRef<Array<any>>([]);
  const responseStatusParams = useRef<Array<any>>([]);
  const responseTypeParams = useRef<Array<any>>([]);
  const superfundNPLParams = useRef<Array<any>>([]);
  const superfundNonNPLParams = useRef<Array<any>>([]);
  const componentIsLoaded = useRef<boolean>(false);
  const [checkAllBoxes, setCheckAllBoxes] = useState<boolean>(
    props.siteType !== null ? false : true
  );
  const [signalAChange, setSignalAChange] = useState(Math.random());
  const [toggleOrClear, setToggleOrClear] = useState<string>("toggle");

  // will need one of these functions for each different component
  const updateBrownfieldParams = (paramArray) => {
    brownfieldParams.current = paramArray;
  };

  const updateRCRAParams = (paramArray) => {
    rcraParams.current = paramArray;
  };

  const updateSuperfundNPLParams = (paramArray) => {
    superfundNPLParams.current = paramArray;
  };

  const updateSuperfundNonNPLParams = (paramArray) => {
    superfundNonNPLParams.current = paramArray;
  };

  const updateResponseAuthorityParams = (paramArray) => {
    responseAuthorityParams.current = paramArray;
  };

  const updateResponseStatusParams = (paramArray) => {
    responseStatusParams.current = paramArray;
  };

  const updateResponseTypeParams = (paramArray) => {
    responseTypeParams.current = paramArray;
  };

  const updateIncidentCategoryParams = (paramArray) => {
    incidentCategoryParams.current = paramArray;
  };

  const updateFacilitiesParams = (paramArray) => {
    facilitiesParams.current = paramArray;
  };

  const updateFederalHazardWasteParams = (paramArray) => {
    federalHazardWasteParams.current = paramArray;
  };

  const updateRecoveryActParams = (paramArray) => {
    recoveryActParams.current = paramArray;
  };

  const updateNatlSignificanceParams = (paramArray) => {
    natlSignificanceParams.current = paramArray;
  };

  // Compose one array from all basic filter sections so we can build where text and share state.
  const createParamArray = () => {
    return [
      ...brownfieldParams.current,
      ...facilitiesParams.current,
      ...federalHazardWasteParams.current,
      ...incidentCategoryParams.current,
      ...natlSignificanceParams.current,
      ...rcraParams.current,
      ...recoveryActParams.current,
      ...responseAuthorityParams.current,
      ...responseStatusParams.current,
      ...responseTypeParams.current,
      ...superfundNPLParams.current,
      ...superfundNonNPLParams.current,
    ];
  };

  const createLabelBooleanMap = (paramArray: Array<any>) => {
    const selectedParams = new Set(paramArray);
    const labelBooleans: Record<string, boolean> = {};
    Object.entries(basicCleanupLabelToParam).forEach(([label, param]) => {
      labelBooleans[label] = selectedParams.has(param);
    });
    return labelBooleans;
  };

  const clearAllParams = (togglingFromSwitch?: boolean) => {
    setCheckAllBoxes(false);
    setSignalAChange(Math.random());
    brownfieldParams.current =
      facilitiesParams.current =
      incidentCategoryParams.current =
      federalHazardWasteParams.current =
      natlSignificanceParams.current =
      rcraParams.current =
      recoveryActParams.current =
      responseAuthorityParams.current =
      responseStatusParams.current =
      responseTypeParams.current =
      superfundNPLParams.current =
      superfundNonNPLParams.current =
        [];
    // Keep shared cleanup state aligned with a cleared basic filter.
    if (props.updateCleanupParamArray) {
      props.updateCleanupParamArray([]);
    }
    if (props.updateActiveCleanupFilterType) {
      props.updateActiveCleanupFilterType('basic');
    }
    if (props.updateBasicCleanupFilterDescription) {
      props.updateBasicCleanupFilterDescription("no filter applied");
    }
    setToggleOrClear("clear");
    if (togglingFromSwitch) {
      props.generalClearAll();
    }
  };

  const toggleAllParams = (togglingFromSwitch?: boolean) => {
    setCheckAllBoxes(true);
    setSignalAChange(Math.random());
    if (props.updateCleanupParamArray) {
      props.updateCleanupParamArray(createParamArray());
    }
    if (props.updateActiveCleanupFilterType) {
      props.updateActiveCleanupFilterType('basic');
    }
    if (props.updateBasicCleanupFilterDescription) {
      props.updateBasicCleanupFilterDescription("no filter applied");
    }
    setToggleOrClear("toggle");
    if (togglingFromSwitch) {
      props.generalToggleAll();
    }
  };

  const createWhereString = () => {
    const paramArray: Array<any> = createParamArray();
    // Publish raw clauses so sibling tools can reuse active cleanup filters.
    if (props.updateCleanupParamArray) {
      props.updateCleanupParamArray(paramArray);
    }
    if (props.updateActiveCleanupFilterType) {
      props.updateActiveCleanupFilterType('basic');
    }
    if (props.updateBasicCleanupFilterDescription) {
      props.updateBasicCleanupFilterDescription(
        formatBasicCleanupFilters(createLabelBooleanMap(paramArray))
      );
    }
    if (paramArray.length > 0) {
      // const whereString = "(" + paramArray.join(") OR (") + ")";
      props.generalSetLayerViewFilter(`(${paramArray.join(") OR (")})`, 'basic');
    } else {
      props.generalClearAll();
    }
  };

  useEffect(() => {
    if (componentIsLoaded.current) clearAllParams(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shouldClear]);

  useEffect(() => {
    if (componentIsLoaded.current) toggleAllParams(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shouldToggle]);
  
  useEffect(() => {
    componentIsLoaded.current = true;
  }, [checkAllBoxes, signalAChange, toggleOrClear]);

  return (
    <>
      <div>
        <div className={switchStyles.controlsDiv}>
          <CalciteButton
            className={styles.FilterAndZoomButtons}
            onClick={() => {
              createWhereString();
            }}
            iconStart={"layer-filter"}
          >
            Filter
          </CalciteButton>
          <div className={switchStyles.toggleSwitchDiv}>
            <label className={switchStyles.toggleLabel}>
              Toggle All Cleanups
            </label>
            {toggleOrClear === "clear" && (
              <CalciteSwitch
                onCalciteSwitchChange={() => {
                  toggleAllParams(true);
                }}
              />
            )}
            {toggleOrClear === "toggle" && (
              <CalciteSwitch
                checked
                onCalciteSwitchChange={() => {
                  clearAllParams(true);
                }}
              />
            )}
          </div>
        </div>

        {/* standard section */}
        <CalcitePanel className={styles.ParentPanels}>
          <label className={styles.SectionLabels}>
            Brownfield, RCRA, and Superfund filters
          </label>

          <div className={styles.SectionContainers}>
            <div className={styles.TopSectionInThirds}>
              <BasicBrownfieldFilter
                sitesLayer={props.sitesLayer}
                updateBrownfieldParams={updateBrownfieldParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "brownfields"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>
            <div className={styles.TopSectionInThirds}>
              <BasicRCRAFilter
                sitesLayer={props.sitesLayer}
                updateRCRAParams={updateRCRAParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "rcra"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>

            <div className={styles.TopSectionInThirds}>
              <div className={styles.VerticalStackContainers}>
                <BasicSuperfundNPLFilter
                  sitesLayer={props.sitesLayer}
                  updateSuperfundNPLParams={updateSuperfundNPLParams}
                  checkAllBoxes={checkAllBoxes}
                  signalAChange={signalAChange}
                  customRouteUsed={props.siteType === "superfund"}
                  updateDefinitionExpression={() => {
                    // updateDefinitionExpression();
                    createWhereString();
                  }}
                />
                <BasicSuperfundNonNPLFilter
                  sitesLayer={props.sitesLayer}
                  updateSuperfundNonNPLParams={updateSuperfundNonNPLParams}
                  checkAllBoxes={checkAllBoxes}
                  signalAChange={signalAChange}
                  customRouteUsed={props.siteType === "superfund"}
                  updateDefinitionExpression={() => {
                    // updateDefinitionExpression();
                    createWhereString();
                  }}
                />
              </div>
            </div>
          </div>
        </CalcitePanel>

        {/* response sections */}
        <CalcitePanel className={styles.ParentPanels}>
          <label className={styles.SectionLabels}>Responses</label>
          <div className={styles.SectionContainers}>
            <div className={styles.VerticalStackContainers}>
              <BasicResponseTypeFilter
                sitesLayer={props.sitesLayer}
                updateResponseTypeParams={updateResponseTypeParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
              <BasicResponseStatusFilter
                sitesLayer={props.sitesLayer}
                updateResponseStatusParams={updateResponseStatusParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
            <div className={styles.VerticalStackContainers}>
              <BasicIncidentCategoryFilter
                sitesLayer={props.sitesLayer}
                updateIncidentCategoryParams={updateIncidentCategoryParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "removals"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicResponseAuthorityFilter
                sitesLayer={props.sitesLayer}
                updateResponseAuthorityParams={updateResponseAuthorityParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
          </div>
        </CalcitePanel>

        {/* third section */}
        <CalcitePanel className={styles.ParentPanels}>
          <div className={styles.SectionContainers}>
            <div className={styles.VerticalStackContainers}>
              <BasicFederalFacilitiesFilter
                sitesLayer={props.sitesLayer}
                updateFacilitiesParams={updateFacilitiesParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "federalfacilities"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicRecoveryActFilter
                sitesLayer={props.sitesLayer}
                updateRecoveryActParams={updateRecoveryActParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "recovery"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>
            <div className={styles.VerticalStackContainers}>
              <BasicHazardWasteFilter
                sitesLayer={props.sitesLayer}
                updateFederalHazardWasteParams={updateFederalHazardWasteParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "docket"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicNationalSignificanceFilter
                sitesLayer={props.sitesLayer}
                updateNatlSignificanceParams={updateNatlSignificanceParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
          </div>
        </CalcitePanel>
      </div>
    </>
  );
};

export default BasicCleanupsFilter;
